  <div *ngIf="showContext" data-cy="file-manager-view-context-container">
    <app-file-manager-context [positionX]="contextPositionX"
                              [positionY]="contextPositionY"
                              [clickedEmptySpace]="clickedEmptySpace"
                              (close)="showContext=false"
                              (upload)="handleUploadClicked()"
                              data-cy="file-manager-view-context-menu">
    </app-file-manager-context>
  </div>

  <div class="main-container" 
       [class.needs-outline]="!isLoading && !dataDocuments.length && previewType !== 'patient'"
       *ngIf="PatientId"
       (click)="hideContextMenu()"
       oncontextmenu="return false;"
       (contextmenu)="onRightClickScheduleEvent($event, item)"
       [style.max-width.px]="width"
       [style.max-height.px]="height"
       [style.width.px]="width"
       [style.height.px]="height"
       data-cy="file-manager-view-main-container">
    <div *ngIf="isLoading" class="spinner-container" data-cy="file-manager-view-loading">
      <mat-spinner [diameter]="20" data-cy="file-manager-view-spinner"></mat-spinner>
    </div>

    <div *ngIf="!isLoading && !dataDocuments.length" data-cy="file-manager-view-empty-state">
      <img
        *ngIf="previewType === 'patient'"
        [class.round]="roundImage" [class.roundcorners]="roundCorners"
        [style.max-height.px]="width"
        [style.max-width.px]="width"
        src="assets/Images/defaultPatient.PNG"
        class="file-preview-image"
        data-cy="file-manager-view-default-patient" />

      <div *ngIf="previewType !== 'patient'" style="height: 100%; text-align: center;" data-cy="file-manager-view-default-document">
        <div style="text-align: left; padding-left: 6px; padding-bottom: 10px;" data-cy="file-manager-view-title-container">
          <span style="font-size: 12px; text-align: left; width: 100%;" data-cy="file-manager-view-title">{{previewTitle}}</span>
        </div>
        <img src="assets/Images/icons8-mouse-right-click.svg" data-cy="file-manager-view-right-click-icon" />
      </div>
    </div>

    <div *ngIf="!isLoading && dataDocuments.length"
         [class.horizontal-container]="orientation !== 'vertical'"
         [class.vertical-container]="orientation === 'vertical'"
         [style.width.px]="width"
         [style.height.px]="height"
         data-cy="file-manager-view-documents-container">
      <div *ngFor="let document of dataDocuments; let i = index"
           [class.horizontal]="orientation !== 'vertical'"
           [class.vertical]="orientation === 'vertical'"
           data-cy="file-manager-view-document-{{i}}">
        <app-file-manager-image
          [roundImage]="roundImage" [roundCorners]="roundCorners"
          [height]="orientation === 'horizontal' || orientation === 'fixed' ? height : null"
          [width]="orientation === 'vertical' || orientation === 'fixed'? width : null"
          
          [maxHeight]="orientation === 'fixed' ? height : null"
          [maxWidth]="orientation === 'fixed' ? width : null"
          [documentID]="document.DocumentID"
          data-cy="file-manager-view-image-{{i}}"></app-file-manager-image>
      </div>
    </div>
  </div>